import { render, staticRenderFns } from "./PaymentStatusMessage.vue?vue&type=template&id=80ba5f3e"
import script from "./PaymentStatusMessage.vue?vue&type=script&lang=js"
export * from "./PaymentStatusMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports